/**
 * Разделить полное имя на имя и фамилию.
 * Во Вьетнаме полное имя вводится так: [Family Name] [Middle Name] [Given Name].
 * Где [Family Name] - это surname, т.е. last_name,
 * а [Middle Name] [Given Name] - это first_name.
 */
export function splitVnFullName(fullName: string): {
    firstName: string | null
    lastName: string | null
} {
    const parts: string[] = fullName.trim().split(/[\s.,:]+/)
    return {
        firstName: parts.length > 1 ? parts.slice(1).join(' ') : null,
        lastName: parts.length > 0 ? parts[0] : null,
    }
}
